export default __webpack_public_path__ + "static/media/portfolio.99ade4e6.jpg";